export { default } from './part-superior-technology';
